import { useState } from "react";
import NewPhoneOrderTab from "./NewPhoneOrderTab";
import PhoneCustomerDirectoryTab from "./PhoneCustomerDirectoryTab";
import PhoneOrderLedgerTab from "./PhoneOrderLedgerTab";

type PhoneView = "new" | "ledger" | "directory";

const VIEWS: { key: PhoneView; label: string; icon: string }[] = [
  { key: "new", label: "Yeni Sipariş", icon: "bi-telephone-inbound-fill" },
  { key: "ledger", label: "Sipariş Kayıtları", icon: "bi-list-ul" },
  { key: "directory", label: "Müşteri Dizini", icon: "bi-journal-bookmark-fill" },
];

interface Props {
  restaurantId: string;
}

export default function PhoneOrderTab({ restaurantId }: Props) {
  const [view, setView] = useState<PhoneView>("new");

  return (
    <div className="po">
      <div className="po-subtabs" role="tablist">
        {VIEWS.map((v) => (
          <button key={v.key} type="button" role="tab" aria-selected={view === v.key}
            className={`po-subtab${view === v.key ? " po-subtab--active" : ""}`}
            onClick={() => setView(v.key)}>
            <i className={`bi ${v.icon}`}></i>
            <span>{v.label}</span>
          </button>
        ))}
      </div>

      {view === "new" && (
        <NewPhoneOrderTab restaurantId={restaurantId} onGoToLedger={() => setView("ledger")} />
      )}
      {view === "ledger" && <PhoneOrderLedgerTab restaurantId={restaurantId} />}
      {view === "directory" && <PhoneCustomerDirectoryTab restaurantId={restaurantId} />}
    </div>
  );
}
